// Libraries
import { omit } from 'lodash/fp'

/**
 * Determines which redux-logger transformers we need based on options.
 * @method setupTransformers
 * @param  {Object} options
 * @return {Object} An object of transformers to be provided to redux-logger.
 */
export default function setupTransformers (options) {
  // A "pipeline" of all redux-logger action transformers.
  function actionPipeline (transformers) {
    return function (action) {
      transformers.forEach(function (transformer) {
        action = transformer(action)
      })
      return action
    }
  }

  const transformers = {}
  const actionTransformers = []
  if (!options.exposePayloads) {
    // If exposePayloads is disabled, include the removePayloads transformer
    actionTransformers.push(removePayloads)
  } else {
    // Otherwise, we should still hide passwords
    actionTransformers.push(passwordHider)
  }
  // Create the actionTransformer pipeline with the included transformers.
  transformers.actionTransformer = actionPipeline(actionTransformers)

  return transformers
}

// Redux-logger actionTransformer to prevent passwords from being logged.
function passwordHider (action) {
  if (action.meta && action.meta.isSensitive) {
    // Only log the action name for actions that have sensitive data in them.
    return omit('payload', action)
  }
  return action
}

/**
 * Helper function removes secure data if secure mode is enabled
 * @param {Object} action
 */
function removePayloads (action) {
  if (!(action.meta && action.meta.isSafe)) {
    return omit('payload', action)
  }
  return action
}
